import { render, staticRenderFns } from "./OurEquipment.vue?vue&type=template&id=87189116&scoped=true"
import script from "./OurEquipment.vue?vue&type=script&lang=js"
export * from "./OurEquipment.vue?vue&type=script&lang=js"
import style0 from "./OurEquipment.vue?vue&type=style&index=0&id=87189116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87189116",
  null
  
)

export default component.exports